module.exports = __webpack_public_path__ + "869d9d75b1f0805d6f3bfb0bd22fe8aa.png";